/* eslint-disable no-unused-vars */
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["PHONE"] = "PHONE";
    Breakpoint["TABLET"] = "TABLET";
    Breakpoint["DESKTOP"] = "DESKTOP";
    Breakpoint["WIDE"] = "WIDE";
})(Breakpoint || (Breakpoint = {}));
export const breakpoints = {
    [Breakpoint.PHONE]: 576,
    [Breakpoint.TABLET]: 768,
    [Breakpoint.DESKTOP]: 1024,
    [Breakpoint.WIDE]: 1280,
};
